import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ExpandMore } from "@material-ui/icons";

import { SubMenuItem } from "./styles";
import RichTooltip from "../../RichTooltip/RichTooltip";
import { useMainState } from "modules/app/contexts";

export default function LinkMenu({ link }) {
  const [open, setOpen] = useState(false);
  const { user } = useMainState();
  const history = useHistory();

  if ((link?.onlyMaster && user?.role == "seller") || !user) {
    return <></>;
  }

  return (
    <div>
      {link.subLinks ? (
        <RichTooltip
          content={() =>
            link.subLinks.map((subLink) =>
              subLink.subLinks ? (
                <div key={subLink.name}>
                  <SubMenuItem disabled>{subLink.name}</SubMenuItem>

                  {subLink.subLinks.map((subSubLink) => (
                    <SubMenuItem key={subSubLink.name}>
                      <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => {
                          history.push(subSubLink.url);
                          setOpen(false);
                        }}
                      >
                        <strong>{subSubLink.name}</strong>
                      </Button>
                    </SubMenuItem>
                  ))}
                </div>
              ) : (
                <SubMenuItem
                  key={subLink.name}
                  onClick={() => {
                    history.push(subLink.url);
                    setOpen(false);
                  }}
                >
                  {subLink.name}
                </SubMenuItem>
              )
            )
          }
          open={open}
          placement="bottom"
          onClose={() => setOpen(false)}
        >
          <Button
            onClick={() => setOpen(!open)}
            aria-controls="simple-menu"
            aria-haspopup="true"
          >
            {link.name}
            {link.subLinks && <ExpandMore />}
          </Button>
        </RichTooltip>
      ) : (
        <Button
          onClick={() => {
            setOpen(false);
            history.push(link.url);
          }}
          aria-controls="simple-menu"
          aria-haspopup="true"
        >
          {link.name}
        </Button>
      )}
    </div>
  );
}
